export default __webpack_public_path__ + "static/media/img0.796946ad.jpg";